export type DsBuilderData = {
  msId?: string;
  selectedCategory?: string;
  selectedThemeColor?: string;
};

export const DS_BUILDER_STORAGE_KEY = 'dsBuilderData';
